/** @typedef {import('@cardsjd/utilities').OSType} OSType */

import { Device } from '@cardsjd/device';

export default class RateApp {
	os = undefined;
	appName = undefined;
	ios = undefined;
	iosUrl = undefined;
	android = undefined;
	amazon = undefined;
	windows = undefined;
	webURl = undefined;
	email = undefined;

	constructor(options) {
		const appName = options.appName ?? 'App';
		const ios = options.ios ?? null;
		const android = options.android ?? null;
		const windows = options.windows ?? null;
		const web = options.webRateURL ?? 'https://cardsjd.com';
		const amazon = options.amazon ?? null;
		const email = options.email ?? 'jimmy@jdsoftwarellc.com';
		const emailSubject = options.emailSubject ?? `${appName} Feedback`;
		const os = options.os ?? this.getPlatform();

		this.os = os;
		this.appName = appName;
		this.ios = ios;
		this.iosUrl = `itms-apps://itunes.apple.com/app/${ios}`;
		this.android = `market://details?id=${android}`;
		this.amazon = `amzn://apps/android?asin=${amazon}`;
		this.windows = `ms-windows-store://pdp/?ProductId=${windows}`;
		this.webURl = web;
		this.email = `mailto:${email}?subject=${emailSubject}`;
	}

	/**
     * @returns {boolean}
     */
	rate() {
		// //try native rate
		// let rated = this.rateNative();
		// if (rated) return true;

		return this.rateNonNative();
	}

	/**
     * @returns {void}
     */
	rateNative() {
		//rate app natively
		globalThis.cordova?.plugins?.RateAppNative?.rate?.();
	}

	/**
     * @returns {boolean}
     */
	rateNonNative() {
		const os = this.os ?? this.getPlatform();

		switch (os) {
			case 'android':
				window.open(this.android, '_system');
				return true;
			case 'ios':
				window.open(this.iosUrl, '_system');
				return true;
			case 'amazon':
				window.open(this.amazon, '_system');
				return true;
			case 'windows':
				window.open(this.windows, '_system');
				return true;
			case 'windowsPWA':
				window.open(this.windows, '_system');
				return true;
			case 'web':
			default:
				window.open(this.webURl, '_system');
				return true;

		}

	}
	getPlatform() {
		const device = new Device();
		return device.getPlatform();
	}
}

/**
 * @typedef {Object} RateAppConfig
 * @property {string} appName
 * @property {string} [ios]
 * @property {string} [windows]
 * @property {string} [android]
 * @property {string} [webRateURL]
 * @property {string} [amazon]
 * @property {string} [email]
 * @property {string} [emailSubject]
 * @property {OSType} [os] 
 */
